import styled from "styled-components";

export const MyPageContentItem = styled.div`
    background: #fff;
    border-radius: 8px;
    padding: 12px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
    width: 135px;
`

export const HomeContentItem = styled.div`
    background: #fff;
    border-radius: 8px;
    padding: 12px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
    width: 160px;
`

export const ContentImageCover = styled.div`
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
`

export const ContentImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`

export const ContentInfoCover = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
    min-width: 0;
    margin-top: 8px;
`

export const ContentTitle = styled.div`
    line-height: 19px;
    font-weight: 600;
    font-size: 15px;
    cursor: pointer;
    width: 100
`

export const ContentInfoWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 13px;
    color: #666;
    line-height: 19px;
    margin-top: 5px;
    width: 100%;
`

export const ContentAuthor = styled.div`
    word-break: break-all;
    display: inline;
`

export const ContentSeparate = styled.div`
    display: inline;
`

export const ContentType = styled.div`
    display: inline;
`

export const ContentRatingWrapper = styled.div`
    display: inline-flex;
    font-size: 13px;
    color: #666;
    line-height: 19px;
    margin-top: 5px;
    height: 19px;
    gap: 5px;
`

export const ContentRatingStarIcon = styled.img`
    width: 13px;
    height: 13px;
    margin: auto 0;
`

export const ContentRatingScore = styled.div`
   
`

export const ContentRatingCount = styled.div`

`



